import { createRouter, createWebHashHistory } from 'vue-router'
import LandingPage from "@/components/LandingPage.vue";
import Questionnaire from "@/components/Questionnaire/Questionnaire.vue";
import Summary from "@/components/Result/Summary";
import SendData from "@/components/Result/SendData";
import Introduction from "../components/Introduction";
const routes = [
  {
    path: '/options',
    name: 'options',
    component:  LandingPage
  },
  {
    path: '/',
    name: 'home',
    component: Introduction
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: Questionnaire,
  },
  {
    path: '/sendResults',
    name: 'sendResults',
    component: SendData,
  },
  {
    path: '/results',
    name: 'results',
    component: Summary,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
